<template>
  <div id="app">
    <div class="head">
      <div class="head_main">
        <a href="javascript:;" target="_blank" @click="skipRule">成为认证歌手/制作人规则</a>
        <el-dropdown class="avatar-container" trigger="click" v-if="show">
          <div class="avatar-wrapper">
            <span>{{text}}</span>
            <i class="el-icon-caret-bottom"></i>
          </div>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <el-dropdown-item divided>
              <span style="display:block;" @click="logout">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="tab">
      <div class="logo-bg">
        <img src="./assets/image/logo-bg.png" alt />
      </div>
      <div>
        <router-link
          style="margin-left: 32px;width: 75px;padding-bottom: 20px;"
          to="/"
          class="taba"
          active-class="active"
          exact
        >首 页</router-link>
        <router-link
          style="margin-left: 32px;width: 147px;padding-bottom: 20px;"
          to="/center"
          class="taba"
          active-class="active"
          @click.native="center()"
        >个 人 中 心</router-link>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  name: "App",
  created() {
    if (
      this.$store.state.user.name &&
      this.$store.state.user.name != null &&
      this.$store.state.user.name != "" &&
      this.$route.path != "/rule"
    ) {
      this.show = true;
      this.text = this.$store.state.user.name;
    } else {
      this.show = false;
      this.text = "";
    }
  },
  data() {
    return {
      show: false,
      text: "",
    };
  },
  computed: {
    searchText() {
      return this.$store.state.user.name;
    },
  },
  watch: {
    searchText: function (old) {
      if (
        this.$store.state.user.name &&
        this.$store.state.user.name != null &&
        this.$store.state.user.name != "" &&
        this.$route.path != "/rule"
      ) {
        this.show = true;
        this.text = this.$store.state.user.name;
      } else {
        this.show = false;
        this.text = "";
      }
    },
  },
  methods: {
    skipRule() {
      const { href } = this.$router.resolve({
        name: "rule",
      });
      window.open(href, "_blank");
    },
    center() {
      if (
        this.$store.state.user.name == "" ||
        this.$store.state.user.name == null
      ) {
        Message("请先登录");
      }
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  /*background-color: #181818;*/
  width: 100%;
  height: auto;
  min-height: 100%;
  position: absolute;
  letter-spacing: 2px;
  background: url("assets/image/bg7.jpg");
  background-size: cover;
}
.head {
  width: 100%;
  height: 50px;
  background-color: #000;
  border-bottom: 2px solid #a4f310;
  .head_main {
    max-width: 1440px;
    margin: 0 auto;
    height: 50px;
    position: relative;
    a {
      line-height: 50px;
      color: #a4f310;
      font-size: 16px;
      float: right;
      padding-right: 40px;
    }
    span {
      font-family: Tahoma, Arial, "Helvetica Neue", "Hiragino Sans GB", Simsun,
        sans-self;
    }
  }
}
.tab {
  margin: 40px auto 0 auto;
  width: 1200px;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo-bg {
    // background: url("./assets/image/logo-bg.png") no-repeat;
  }
  .taba {
    line-height: 120px;
    font-size: 22px;
    border-bottom: 5px solid #a4f310;
    color: #a4f310;
    text-align: center;
    letter-spacing: 5px;
    cursor: pointer;
  }
  .active {
    color: #ffffff;
    border-bottom: 5px solid #ffffff;
  }
  div {
    position: relative;
    img {
      margin: 8px 0;
    }
    h3 {
      padding-left: 40px;
      position: absolute;
      left: 82px;
      top: 40px;
    }
  }
}
.el-dropdown-menu__item--divided:before {
  margin: 0 0px !important;
  height: 0 !important;
}
.el-dropdown-menu__item {
  padding: 0 !important;
  span {
    padding: 0 20px !important;
  }
}
.el-dropdown {
  position: absolute !important;
  right: 280px !important;
  font-size: 20px !important;
  color: #fff !important;
  top: 8px !important;
  cursor: pointer !important;
}
.el-button {
  background: #a3f310 !important;
  border: 1px solid #a3f310 !important;
  color: #fff !important;
  font-size: 20px !important;
}
.el-button:focus,
.el-button:hover {
  color: #fff !important;
  border-color: #a3f310 !important;
  background-color: #a3f310 !important;
}
.el-form-item.is-success .el-input__inner,
.el-form-item.is-success .el-input__inner:focus,
.el-form-item.is-success .el-textarea__inner,
.el-form-item.is-success .el-textarea__inner:focus {
  border-color: #a3f310 !important;
}
.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #a3f310;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #a3f310;
}
</style>



// WEBPACK FOOTER //
// src/App.vue